import { createSlice } from "@reduxjs/toolkit";
import _ from "lodash";

function convertProxyObjectToPojo(s) {
  return _.cloneDeep(s);
}

const INITIAL_STATE = {
  requestProductList: {
    list: [],
    reachEnd: false,
    Listpage: 1,
    TotalList: null,
    TotalPage: null,
    selectedProductList: [],
  },
  customerSlice: {
    list: [],
    reachEnd: false,
    Listpage: 1,
    TotalList: null,
    TotalPage: null,
  },
  saleOrderSlice: {
    list: [],
    reachEnd: false,
    Listpage: 1,
    TotalList: null,
    TotalPage: null,
    totalAmount: null
  },
  saleReportSlice: {
    list: [],
    reachEnd: false,
    Listpage: 1,
    TotalList: null,
    TotalPage: null,
    Status : null

  },
  saleTeamReportSlice: {
    list: [],
    reachEnd: false,
    Listpage: 1,
    TotalList: null,
    TotalPage: null,
  }
}
export const yourSlice = createSlice({
  name: "yourSlice",
  initialState: INITIAL_STATE,
  reducers: {
    setCustomerListing: (state, action) => {
      state.list = action.payload.data;
    },
  },
});

export const requestProductSlice = createSlice({
  name: "requestProductSlice",
  initialState: INITIAL_STATE.requestProductList,
  reducers: {
    setRequestProductList: (state, action) => {
      // state.list = action.payload.data
      state.list = action.payload.data.map((product) => ({
        ...product,
        isSelected: false,
      }));
      state.TotalList = action.payload.total_items;
      state.TotalPage = action.payload.total_page;
      if (state.list.length == action.payload.total_items) {
        state.reachEnd = true;
      } else {
        state.reachEnd = false;
      }
    },
    toggleProductSelection: (state, action) => {
      state.list = state.list.map((product) =>
        product.id === action.payload
          ? { ...product, isSelected: !product.isSelected }
          : product
      );
    },
    updateRequestProductList: (state, action) => {
      let oldArr = convertProxyObjectToPojo(state.list);
      let newArr = action.payload.data;
      state.TotalList = action.payload.total_items;
      const existingIds = new Set(oldArr.map((element) => element.id));

      const uniqueList = newArr.filter((element) => {
        if (existingIds.has(element.id)) {
          const existingIndex = oldArr.findIndex(
            (existingElement) => existingElement.id === element.id
          );
          oldArr[existingIndex] = element;
          return false;
        }
        return true;
      });
      const sortedArr = [...oldArr, ...uniqueList];
      state.list = sortedArr;
      if (state.list.length == action.payload.total_items) {
        state.reachEnd = true;
      } else {
        state.reachEnd = false;
      }
    },
    setSelectedProduct: (state, action) => {
      const isSelected = state.selectedProductList?.some(
        (selectedItem) => selectedItem.id === action.payload.id
      );
      if (!isSelected) {
        // Add the item if it is not already selected
        state.selectedProductList.push(action.payload);
      }
    },
    deleteSelectProduct: (state, action) => {
      const existingItem = state.selectedProductList.find(
        (item) => item.id === action.payload
      );
      if (existingItem) {
        state.selectedProductList = state.selectedProductList.filter(
          (item) => item.id !== action.payload
        );
      }
    },
    resetSelectProduct: (state) => {
      state.selectedProductList = [];
    },

    setListpage: (state, action) => {
      state.Listpage = action?.payload;
    },
    plusListpage: (state, action) => {
      state.Listpage = action.payload;
    },
    resetRequestProductList: (state, action) => {
      return INITIAL_STATE.requestProductList;
    },
  },
});

export const customerSlice = createSlice({
  name: "customerSlice",
  initialState: INITIAL_STATE.customerSlice,
  reducers: {
    setCustomerList: (state, action) => {
      state.list = action.payload.data.map((customer) => ({
        ...customer,
        isSelected: false,
      }));
      state.TotalList = action.payload.total_items;
      state.TotalPage = action.payload.total_page;
      if (state.list.length == action.payload.total_items) {
        state.reachEnd = true;
      } else {
        state.reachEnd = false;
      }
    },
    setListpage: (state, action) => {
      state.Listpage = action?.payload;
    },
    plusListpage: (state, action) => {
      state.Listpage = action.payload;
    },
  },
});

export const saleOrderSlice = createSlice({
  name: "saleOrderSlice",
  initialState: INITIAL_STATE.saleOrderSlice,
  reducers: {
    setSaleOrderList: (state, action) => {
      state.list = action.payload.data.map((order) => ({
        ...order,
        isSelected: false,
      }));
      state.TotalList = action.payload.total_items;
      state.TotalPage = action.payload.total_page;
      state.totalAmount = action.payload.total_amount;
      if (state.list.length == action.payload.total_items) {
        state.reachEnd = true;
      } else {
        state.reachEnd = false;
      }
    },
    setListpage: (state, action) => {
      state.Listpage = action?.payload;
    },
    plusListpage: (state, action) => {
      state.Listpage = action.payload;
    },
  },
});

export const saleReportSlice = createSlice({
  name: "saleReportSlice",
  initialState: INITIAL_STATE.saleReportSlice,
  reducers: {
    setSaleReportList: (state, action) => {
      state.list = action.payload.data;
      state.TotalList = action.payload.total_items;
      state.TotalPage = action.payload.total_page;
      if (state.list.length == action.payload.total_items) {
        state.reachEnd = true;
      } else {
        state.reachEnd = false;
      }
    },
    setListpage: (state, action) => {
      state.Listpage = action?.payload;
    },
    plusListpage: (state, action) => {
      state.Listpage = action.payload;
    },
  },
});

export const saleTeamReportSlice = createSlice({
  name: "saleTeamReportSlice",
  initialState: INITIAL_STATE.saleTeamReportSlice,
  reducers: {
    setSaleTeamReportList: (state, action) => {
      state.list = action.payload.data;
      state.TotalList = action.payload.total_records;
      state.TotalPage = action.payload.total_pages;
      if (state.list.length == action.payload.total_records) {
        state.reachEnd = true;
      } else {
        state.reachEnd = false;

      }
    },
    setListpage: (state, action) => {
      state.Listpage = action?.payload;
    },
    plusListpage: (state, action) => {
      state.Listpage = action.payload;
    },
  },
});

export default {
  yourSlice,
  requestProductSlice,
  customerSlice,
  saleOrderSlice, 
  saleReportSlice,
  saleTeamReportSlice
};
